import { IconAlertTriangle } from '@tabler/icons-react';

const BError = ({ title = 'Nous sommes désolés', description = 'Une erreur est survenue' }) => {
  return (
    <div className={`flex flex-col items-center justify-center px-4 text-center`}>
      <IconAlertTriangle className="text-red-600" size={48} stroke={2} />
      <h1 className="mt-6 text-2xl font-semibold text-slate-700">{title}</h1>
      <p className="max-w-md text-slate-400">{description}</p>
    </div>
  );
};

export default BError;
